import React from 'react';
import PropTypes from 'prop-types';
import {
  ThemeProvider,
  crTheme
} from '@comicrelief/component-library';
import { snakeCase } from 'lodash';
import HeaderNoData from '../Header/HeaderNoData';
import Footer from '../Footer/Footer';

import 'lazysizes';

import '@comicrelief/component-library/dist/style.css';

import {
  Wrapper, SkipNav, Main, HeaderWrapper, ContentArea, FooterWrapper
} from './Layout.styles';

const LayoutNoData = ({
  children,
  menu,
  landingPageCartId = null,
  backgroundColour = ''
}) => {
  const thisBgColour = snakeCase(backgroundColour || 'grey_light');

  return (
    <ThemeProvider theme={crTheme}>
      <SkipNav href="#main-content">
        Skip to main content
      </SkipNav>
      <Wrapper backgroundColour={thisBgColour}>
        <HeaderWrapper>
          <HeaderNoData
            menu={menu}
            landingPageCartId={landingPageCartId}
          />
        </HeaderWrapper>
        <ContentArea>
          <Main role="main" id="main-content">
            {children}
          </Main>
          <FooterWrapper>
            <Footer />
          </FooterWrapper>
        </ContentArea>
      </Wrapper>
    </ThemeProvider>
  );
};

LayoutNoData.propTypes = {
  children: PropTypes.node.isRequired,
  menu: PropTypes.objectOf(PropTypes.shape).isRequired,
  landingPageCartId: PropTypes.string,
  backgroundColour: PropTypes.string
};

export default LayoutNoData;
